import { createReducer, on } from '@ngrx/store';
import { initialState } from './admin-orders.state';
import * as AdminOrdersActions from './admin-orders.actions';

export const adminOrdersReducer = createReducer(
  initialState,
  on(AdminOrdersActions.loadAdminOrders, (state, { page }) => ({
    ...state,
    currentPage: page,
    isLoading: true,
    error: null
  })),
  on(AdminOrdersActions.loadAdminOrdersSuccess, (state, { orderPage }) => ({
    ...state,
    orders: orderPage.content,
    totalElements: orderPage.totalElements,
    totalPages: orderPage.totalPages,
    isLoading: false
  })),
  on(AdminOrdersActions.loadAdminOrdersFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false
  }))
);
